import TextBox from "devextreme-react/text-box";
import React, {useEffect, useState} from "react";
import {NumberBox} from "devextreme-react/number-box";
import {SelectBox} from "devextreme-react/select-box";
import Box, {Item} from 'devextreme-react/box';
import {Countertop} from "../../types/Countertop";
import {useCountertops} from "../../contexts/countertopsContext";
import {useGetMaterials} from "../../api/get-materials";
import {useGetColors} from "../../api/get-colors";
import {BacksplashLineControl} from "./BacksplashLineControl";
import Validator from "devextreme-react/validator";
import {CustomRule, RequiredRule} from "devextreme-react/form";
import { formatMoney } from "../../../../../utils/string-utils";

export function ShapeLineControl({shape}: { shape: Countertop }) {
    const context = useCountertops();

    const materials = useGetMaterials(context.dealerId, context.customerZip);
    const colors = useGetColors(context.dealerId, shape.prodQteGrpID ?? 0, context.estimateDate, context.customerZip)
    const [imageUrl, setImageUrl] = useState('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
    const [price, setPrice] = useState<null | number>(null);

    useEffect(() => {
        if (colors.isLoading) {
            return;
        }
        let item = colors.data.find(element => element.productID === shape.productID);
        if (item === undefined) {
            return;
        }

        setImageUrl(item.imageUrl);
        setPrice(item.amount);
    }, [colors.isLoading, shape.productID])

    return (
        <div style={{padding: "10px"}}>
            <Box
                direction="row"
                width="100%"
                align='center' crossAlign='center'>
                <Item ratio={6}>
                    <Box>
                        <Item ratio={2}>
                            <div style={{marginRight: '20px', textAlign: 'right'}}>
                                <label>
                                    &nbsp;
                                    <TextBox mode='text' stylingMode='outlined' value={shape.name}
                                             inputAttr={{"style": "text-align:right"}} valueChangeEvent={'blur'}
                                             onValueChanged={(e) => {
                                                 context.updateShapeName(shape.id, e.value);

                                             }}></TextBox>
                                </label>
                            </div>
                        </Item>
                        <Item ratio={2}>
                            <div style={{marginRight: "20px"}}>
                                <label>
                                    Material*
                                </label>
                                <SelectBox disabled={materials.isLoading || materials.data.length === 0}
                                           dataSource={materials.data} displayExpr="name" value={shape.prodQteGrpID}
                                           searchEnabled={true}
                                           valueExpr="prodQteGrpID" onValueChanged={(e) => {
                                    if (materials.data.length > 0) {
                                        let item = materials.data.find(element => element.prodQteGrpID === e.value);
                                        if (item === undefined) {
                                            return;
                                        }

                                        if (e.event === undefined) // value changed in context
                                            return;

                                        context.setShapeGroup(shape.id, e.value, item.name)
                                    }
                                }}></SelectBox>
                            </div>
                        </Item>
                        <Item ratio={3}>
                            <div style={{marginRight: "20px"}}>
                                <label>
                                    Color*
                                </label>
                                <SelectBox disabled={colors.isLoading || shape.prodQteGrpID === null}
                                           dataSource={colors.data} displayExpr="name"
                                           searchEnabled={true}
                                           value={shape.productID}
                                           valueExpr="productID" onValueChanged={(e) => {
                                    if (colors.data.length > 0 && e.value !== null) {
                                        let item = colors.data.find(element => element.productID === e.value);
                                        if (item === undefined) {
                                            return;
                                        }

                                        context.setShapeProduct(shape.id, e.value, item.name);
                                    }
                                }}></SelectBox>
                            </div>
                        </Item>
                    </Box>
                </Item>
                <Item ratio={4}>
                    <Box crossAlign='center'>
                        <Item baseSize={70}>
                            <label>
                                Length(in)
                                <NumberBox
                                    stylingMode='outlined'
                                    inputAttr={{"style": "text-align:center"}}
                                    disabled={(shape.productID ?? 0) === 0}
                                    value={shape.length}
                                    valueChangeEvent='blur'
                                    onValueChanged={(e) => {
                                        if (e.event) {
                                            let value: number | undefined = undefined;
                                            if (e.value !== null && e.value !== undefined) {
                                                value = +(e.value).toFixed(2);
                                            }

                                            let total: number | undefined = undefined;
                                            if (value !== undefined && shape.width !== undefined) {
                                                total = +(((shape.width ?? 0) * e.value) / 144).toFixed(2);
                                                total = Math.ceil(total);
                                            }

                                            context.updateShapeDimensions(shape.id, value, shape.width, total)
                                        }
                                    }}
                                />
                            </label>
                        </Item>
                        <Item baseSize={30}>
                            <label>
                                &nbsp;
                            </label>
                            <div style={{
                                justifyContent: "center",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                textAlign: "center"
                            }}>
                                <i className="dx-icon-close" style={{display: "block"}}></i>
                            </div>
                        </Item>
                        <Item baseSize={70}>
                            <label>
                                Width(in)
                                <NumberBox
                                    stylingMode='outlined'
                                    inputAttr={{"style": "text-align:center"}}
                                    disabled={(shape.productID ?? 0) === 0}
                                    value={shape.width}
                                    valueChangeEvent='blur'
                                    onValueChanged={(e) => {
                                        if (e.event) {
                                            let value: number | undefined = undefined;
                                            if (e.value !== null && e.value !== undefined) {
                                                value = +(e.value).toFixed(2);
                                            }

                                            let total: number | undefined = undefined;
                                            if (value !== undefined && shape.length !== undefined) {
                                                total = +(((shape.length ?? 0) * e.value) / 144).toFixed(2);
                                                total = Math.ceil(total);
                                            }

                                            context.updateShapeDimensions(shape.id, shape.length, value, total);
                                        }
                                    }}
                                />
                            </label>
                        </Item>
                        <Item baseSize={30}>
                            <label>
                                &nbsp;
                            </label>
                            <div style={{
                                justifyContent: "center",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                textAlign: "center"
                            }}>
                                <i className="dx-icon-equal" style={{display: "block"}}></i>
                            </div>
                        </Item>
                        <Item baseSize={70}>
                            <label>
                                Total(sq. ft.)
                                <NumberBox
                                    stylingMode='outlined'
                                    inputAttr={{"style": "text-align:center"}}
                                    disabled={(shape.productID ?? 0) === 0}
                                    value={shape.total}
                                    onValueChanged={(e) => {
                                        if (e.event) {
                                            let value: number | undefined = undefined;
                                            if (e.value !== null && e.value !== undefined) {
                                                value = +(e.value).toFixed(2);
                                                value = Math.ceil(value);
                                            }
                                            context.updateShapeDimensions(shape.id, shape.length, shape.width, value)
                                        }
                                    }}
                                >
                                    <Validator>
                                        <CustomRule message={"Quantity must be set and greater than 0"}
                                                    validationCallback={context.qtyValidation}></CustomRule>
                                        <RequiredRule
                                            message={"Quantity must be set and greater than 0"}></RequiredRule>
                                    </Validator>
                                </NumberBox>
                            </label>
                        </Item>
                        <Item baseSize={70}>
                            <img style={{
                                width: "60px",
                                height: "60px",
                                marginLeft: '20px',
                                border: '1px solid #ccc',
                                borderRadius: '10px',
                                filter: 'drop-shadow(2px 2px 2px #ccc)'
                            }} src={imageUrl}></img>
                        </Item>
                        <Item>
                            <label style={{marginRight: "10px", marginLeft: "10px"}}>
                                &nbsp;
                            </label>
                            <a style={{color: 'red', marginLeft: '20px'}}
                               onClick={() => context.removeShape(shape.id)}>Remove</a>
                            {context.showPrices && (price !== null) ?
                                <span style={{marginLeft: '20px'}}>{formatMoney(price)}</span> : <></>}
                        </Item>
                    </Box>
                </Item>
            </Box>
            {shape.backsplashes.map((backsplash) =>
                <BacksplashLineControl key={backsplash.id} shapeId={shape.id} colorName={shape.colorName}
                                       materialName={shape.materialName} backsplash={backsplash}/>
            )}
            <Box
                direction="row"
                width="100%">
                <Item ratio={6}>
                    <Box style={{textAlign: 'right'}}>
                        <Item ratio={2}>
                            <a style={{textDecoration: "none", marginRight: "20px", marginTop: '10px'}}
                               onClick={() => context.addBacksplash(shape.id)}><i
                                className="dx-icon-add"></i>Add Backsplash</a>
                        </Item>
                        <Item ratio={5}>
                        </Item>
                    </Box>
                </Item>
                <Item ratio={4}>
                </Item>
            </Box>
        </div>
    );
}

const userNameEditorOptions = {stylingMode: 'outlined', labelMode: 'floating', placeholder: 'User Name', mode: 'text'};
